var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Comment',{staticClass:"loading-blur",attrs:{"comment":_vm.fakeComment}})}
var staticRenderFns = []

export { render, staticRenderFns }